/* eslint-disable no-shadow */
import React, { useState, useEffect } from 'react'
import classNames from 'classnames'
import Button from '../button'
import Ul, { Li } from '../ul'
import Checkbox from '../checkbox'
import Input from '../input'
import { findItemsByValues } from './util'
import './list.less'

const List = (props) => {
  const { className, style, data = [], value = null, onChange, allowClear = true, readOnly, ulProps, onMouseEnter } = props
  return <Ul className={className} style={{ maxHeight: 500, ...style }} ulProps={ulProps}>
    {allowClear ? <Li active={value === null} onClick={() => onChange(null)}>不限</Li> : null}
    {data?.map(item => <Li
      key={item.value}
      active={value === item.value}
      disabled={item.disabled}
      readOnly={readOnly}
      onClick={() => {
        onChange && onChange(item.value, item)
      }}
      onMouseEnter={e => onMouseEnter && onMouseEnter(item.value, e)}
    >{item.label}</Li>)}
  </Ul>
}

List.Multi = (props) => {
  const {
    className, style, data = [], value = [], onOk, onClear, onChangeInner, visible,
    hiddenSearch, screen = '', showPrefix, emptyText, dataFilter
  } = props
  const [valueInner, setValueInner] = useState(value)
  const [keyWords, setKeyWords] = useState(screen)
  useEffect(() => {
    setValueInner(value)
  }, [visible, JSON.stringify(value)])
  useEffect(() => {
    setKeyWords('')
  }, [visible])
  useEffect(() => { setKeyWords(screen) }, [screen])
  const getData = (data, keyWords, dataFilter) => {
    if (!dataFilter) return data.filter(m => (keyWords ? m.label.includes(keyWords) : true))
    return data.filter(m => dataFilter(valueInner, data).includes(m)).filter(n => (keyWords ? n.label.includes(keyWords) : true))
  }
  return <>
    {!hiddenSearch ? <Input.Search value={keyWords} onChange={key => setKeyWords(key)} wrapStyle={{ margin: '16px 16px 12px' }} /> : null}
    <Ul className={classNames('meinian-select-list-multi', className)} style={style}>
      {getData(data, keyWords, dataFilter).length
        ? getData(data, keyWords, dataFilter).map(item => <Li className="item-multi" active={valueInner.includes(item.value)} disabled={item.disabled} title={item.label}>
          <Checkbox
            value={item.value}
            key={item.value}
            checked={valueInner.includes(item.value)}
            onChange={(e) => {
              let inner = []
              if (e.target.checked) {
                inner = [...valueInner, item.value]
              } else {
                inner = valueInner.filter(m => m !== item.value)
              }
              setValueInner(inner)
              onChangeInner?.(inner)
            }}
          >
            <span className="prefix">{showPrefix ? item.prefix : null}</span>{item.label}
          </Checkbox>
        </Li>) : <div className="empty">{emptyText || '暂无相关结果'}</div>}
    </Ul>
    {getData(data, keyWords, dataFilter).length ? <div className="meinian-select-action-btn">
      <Button type="normal" style={{ marginRight: 16 }} onClick={onClear}>清空</Button>
      <Button type="primary" onClick={() => onOk(valueInner)}>确认</Button>
    </div> : null}
  </>
}

List.Cascade = (props) => {
  const {
    className, style, data = [], value = [], onOk, onClear, defaultLeftValue, dataFilter, multi, rootSelectable,
    hiddenSelected, visible, hiddenSearch, onSearch, emptyText, leftSlot, inputPlaceholder, onChangeInner, ...otherProps
  } = props
  const getValueRoot = (inner) => {
    if (!multi) return []
    const roots = []
    data.forEach((root) => {
      if (root.children?.map(m => m.value).every(n => inner.includes(n))) {
        roots.push(root.value)
      }
    })
    return roots
  }
  const [valueInner, setValueInner] = useState(value)
  const [valueRoot, setValueRoot] = useState(getValueRoot(value))
  const [leftValue, setLeftValue] = useState(defaultLeftValue)
  const [keyWords, setKeyWords] = useState('')
  const [, refresh] = useState(false)
  useEffect(() => {
    if (hiddenSelected || !multi) return
    data[0].children = []
    data[0].children = findItemsByValues(valueInner, data)
    refresh(pre => !pre)
  }, [valueInner])

  useEffect(() => {
    setValueInner(value)
  }, [visible, JSON.stringify(value)])
  useEffect(() => {
    setKeyWords('')
  }, [visible])

  return <div className={classNames('meinian-select-list-cascade', className)} style={style}>
    <div className="left">
      {rootSelectable && multi ? <Ul className="left-list" style={style}>
        {data.map(item => <Li
          className="item-multi"
          active={valueRoot.includes(item.value)}
          disabled={item.disabled}
          onMouseEnter={() => {
            setLeftValue(item.value)
            onSearch && onSearch(leftValue)
          }}
        >
          <Checkbox
            value={item.value}
            key={item.value}
            checked={valueRoot.includes(item.value)}
            onChange={(e) => {
              let roots = []
              let inner = []
              if (e.target.checked) {
                roots = [...valueRoot, item.value]
                inner = Array.from(new Set([...valueInner, ...item.children.map(m => m.value)]))
                setValueInner(inner)
                onChangeInner?.(inner)
              } else {
                roots = valueRoot.filter(m => m !== item.value)
                inner = valueInner.filter(m => !item.children.find(n => n.value === m))
                setValueInner(inner)
                onChangeInner?.(inner)
              }
              setValueRoot(roots)
              setValueInner(inner)
              onChangeInner?.(inner)
            }}
          >
            {item.label}
          </Checkbox>
        </Li>)}
      </Ul> : <Ul
        data={data}
        readOnly={!rootSelectable}
        value={leftValue}
        onChange={(val, item) => onOk(val, { level: 1, ...item })}
        onMouseEnter={(val) => {
          setLeftValue(val)
          onSearch && onSearch(leftValue)
        }}
        className="left-list"
      />}
      {leftSlot}
    </div>
    <div className="right">
      {!hiddenSearch ? <div className="search">
        <Input.Search value={keyWords} onChange={key => setKeyWords(key)} placeholder={inputPlaceholder} />
      </div> : null}
      {multi ? <List.Multi
        data={data.find(m => m.value === leftValue)?.children}
        value={valueInner}
        onOk={(val, item) => onOk(val, { level: 2, ...item })}
        onClear={onClear}
        style={{ flex: 1 }}
        onChangeInner={(inner) => {
          setValueRoot(getValueRoot(inner))
          setValueInner(inner)
          onChangeInner?.(inner)
        }}
        visible={visible}
        hiddenSearch
        screen={keyWords}
        showPrefix={leftValue === null}
        emptyText={emptyText}
        dataFilter={dataFilter}
      /> : <List
        {...otherProps}
        data={data.find(m => m.value === leftValue)?.children || data.find(m => m.value === defaultLeftValue)?.children}
        value={valueInner}
        onChange={(val, item) => onOk(val, { level: 2, ...item })}
        onClear={onClear}
        visible={visible}
        className="meinian-select"
      />}
    </div>
  </div>
}
export default List
